import { api } from './client'

export interface StatsOverview {
  orders: {
    total: number
    by_status: Record<string, number>
    active_count: number
    active_portfolio: number
    new_this_month: number
    conversion_pct: number
    trend_30d: { date: string; count: number }[]
  }
  finance: {
    avg_interest_rate: number
    avg_monthly_amount: number
    portfolio_total: number
    expected_interest_income: number
    month_plan: number
    month_collected: number
    month_collected_pct: number
  }
  payments: {
    awaiting_confirmation: number
    overdue_count: number
    overdue_amount: number
    month_count: number
  }
  clients: {
    total: number
    new_this_month: number
    verified: number
    unverified: number
    blocked: number
    by_tier: Record<string, number>
  }
}

export async function getStatsOverview(): Promise<StatsOverview> {
  const res = await api.get('/api/v1/manager/stats/overview')
  return res.data
}
